import React, { useState, useEffect, useContext } from "react";
import { Row, Col, Card, Table, Form, Button, Alert, ProgressBar, Modal } from "react-bootstrap";
import _ from "lodash";
import axios from "axios";
import Utils from "./../../common/Utils";
import { UserContext } from "../../common";
import ChoosePlans from "../../components/application/ChoosePlans";
import VideoPlayer from "../../components/application/VideoPlayer";

const Resources = (props) => {
  const { userData } = useContext(UserContext);
  const [cats, setCats] = useState([]);
  const [subcats, setSubCats] = useState([]);
  const [filter, setFilter] = useState({
    pp: 100,
    cat: 0,
    subcat: 0,
    st: 0,
    txt: "",
  });
  const [data, setData] = useState({
    loading: false,
    total: 0,
    start: 0,
    records: [],
  });
  const [video, setVideo] = useState("");

  const fetchCategory = (pid = 0) => {
    axios
      .get(Utils.apiUrl("resources/fetchcategories") + `?pid=${pid}`, Utils.apiHeaders())
      .then((res) => {
        if (res.data.success) {
          if (pid > 0) {
            setSubCats(res.data.data);
          } else {
            setCats(res.data.data);
          }
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(fetchCategory, []);

  const setCategoryValue = (e) => {
    setFilter({
      ...filter,
      st: 0,
      cat: parseInt(e.currentTarget.value),
      subcat: 0,
    });
    fetchCategory(e.currentTarget.value);
  };

  const setSubCatValue = (e) => {
    setFilter({ ...filter, st: 0, subcat: parseInt(e.currentTarget.value) });
  };

  let stout = null;

  const setSearchTxt = (e) => {
    let txt = e.currentTarget.value;
    if (stout != null) {
      window.clearTimeout(stout);
    }
    stout = window.setTimeout(() => {
      setFilter({ ...filter, st: 0, txt: txt });
    }, 1000);
  };

  const addFilters = (start) => {
    let str = _.compact(_.map(filter, (fv, fk) => (fv !== "" ? `${fk}=${fv}` : undefined)));
    str.push(`st=${start}`);
    return "?" + str.join("&");
  };

  const fetchData = (start = 0) => {
    setData({ ...data, loading: true });
    axios
      .get(Utils.apiUrl("resources/fetchresources") + addFilters(start), Utils.apiHeaders())
      .then((res) => {
        if (res.data.success) {
          setData({
            ...data,
            loading: false,
            start: start,
            total: _.get(res, "data.total", data.total),
            records: res.data.data,
          });
        }
      })
      .catch((err) => {
        setData({ ...data, loading: false });
        console.log(err);
      });
  };

  useEffect(fetchData, [filter]);

  const pageSelect = () => {
    return (
      <select
        className="form-select float-right ms-3"
        style={{ width: "80px" }}
        onChange={(e) => setFilter({ ...filter, pp: parseInt(e.target.value) })}
      >
        {[5, 10, 25, 50, 100].map((p) => (
          <option value={p} selected={filter.pp === p}>
            {p}
          </option>
        ))}
      </select>
    );
  };

  const showPagination = ({ loading, start, total }) => {
    if (loading || (start === 0 && start + filter.pp >= total)) {
      return <></>;
    } else {
      return (
        <>
          {start + filter.pp >= total && (
            <div className="text-disabled ms-2">
              <img src={`${process.env.PUBLIC_URL}/images/arrow-right-d.png`} alt="Next" /> Next
            </div>
          )}
          {start + filter.pp < total && (
            <div className="clickable ms-2 text-clickable" onClick={() => fetchData(start + filter.pp)}>
              <img src={`${process.env.PUBLIC_URL}/images/arrow-right.png`} alt="Next" /> Next
            </div>
          )}
          {start >= filter.pp && (
            <div className="clickable text-clickable" onClick={() => fetchData(start - filter.pp)}>
              Previous <img src={`${process.env.PUBLIC_URL}/images/arrow-left.png`} alt="Previous" />
            </div>
          )}
          {start === 0 && (
            <div className="text-disabled">
              Previous <img src={`${process.env.PUBLIC_URL}/images/arrow-left-d.png`} alt="Previous" />
            </div>
          )}
        </>
      );
    }
  };

  if (!Utils.hasAccess(6) && !userData.is_super_user) {
    return (
      <>
        <h1 className="alert alert-danger p-5 mt-5">No access!</h1>
        {/*userData.is_super_user && <>
            <h1 className="alert alert-danger p-4 mt-4">You current plan is restricted to use this module, please Upgrade!</h1>
            <ChoosePlans onPayment={() => { window.location.reload(); }} />
        </>*/}
      </>
    );
  }

  return (
    <React.Fragment>
      <div>
        <Row>
          <Col>
            <h3 className="my-3 title">Resources</h3>
            <Form>
              <div className="dt-card p-3 mb-3">
                <Row className="g-2 align-items-center">
                  <Col xs={12} sm={6} md={3}>
                    <select className="form-select shadow-cst" onChange={setCategoryValue} value={filter.cat}>
                      <option value="0">All Categories</option>
                      {cats.map((c) => (
                        <option key={c.id} value={c.id}>
                          {c.name}
                        </option>
                      ))}
                    </select>
                  </Col>
                  <Col xs={12} sm={6} md={3}>
                    <select className="form-select shadow-cst" value={filter.subcat} onChange={setSubCatValue}>
                      <option value="0">All Sub Categories</option>
                      {subcats.map((c) => (
                        <option key={c.id} value={c.id}>
                          {c.name}
                        </option>
                      ))}
                    </select>
                  </Col>
                  <Col xs={12} sm={8} md={4}>
                    <input
                      type="text"
                      className="form-control shadow-cst"
                      placeholder="Search by Resource Title..."
                      onKeyUp={setSearchTxt}
                    />
                  </Col>
                  <Col xs={12} sm={4} md={2}>
                    <Button
                      variant="outline-secondary"
                      className="w-100 shadow-cst"
                      onClick={() => setFilter({ ...filter, st: 0, cat: 0, subcat: 0, txt: "" })}
                    >
                      Clear Filter
                    </Button>
                  </Col>
                </Row>
              </div>
            </Form>
          </Col>
        </Row>
        <Row className="mt-4">
          <Col>
            <Card border="light" className="shadow table-section p-sm-0 p-lg-1">
              <Card.Body>
                {data.loading && (
                  <Alert variant="success" className="p-3">
                    <p className="loading-msg">Fetching resources.. </p>
                    <ProgressBar variant="success" animated now={100} />
                  </Alert>
                )}
                {!data.loading && (
                  <>
                    <div className="d-flex flex-row-reverse">
                      {pageSelect()}
                      {showPagination(data)}
                    </div>
                    <Table striped hover responsive>
                      <thead>
                        <tr>
                          <th className="text-center">Sl #</th>
                          <th className="text-center">File</th>
                          <th>Resource Title</th>
                          <th className="text-center">Category</th>
                          <th className="text-center">Sub Category</th>
                        </tr>
                      </thead>
                      <tbody>
                        {data.records.map((d, idx) => (
                          <tr key={d.id}>
                            <td className="text-end">{data.start + idx + 1}.</td>
                            <td className="text-center">
                              {d.ftype === "ext_link" && (
                                <a target="_blank" href={d.fname}>
                                  🔗
                                </a>
                              )}
                              {d.ftype === "link" && (
                                <img
                                  src={`${process.env.PUBLIC_URL}/images/video.png`}
                                  className="clickable"
                                  title="Click to view"
                                  onClick={() => setVideo(d.fname)}
                                  width=""
                                  height=""
                                  alt="Video"
                                />
                              )}

                              {d.ftype === "upload" && (
                                <a target="_blank" href={Utils.viewerLink(d.fname, `resources/download?id=${d.id}`)}>
                                  <img src={Utils.getFileIcon(d.fname)} width="" height="" alt="Download" />
                                </a>
                              )}
                            </td>
                            <td>{d.title}</td>
                            <td className="text-center">{d.catname}</td>
                            <td className="text-center">{d.subcatname}</td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                    <div className="d-flex flex-row-reverse">
                      {pageSelect()}
                      {showPagination(data)}
                    </div>
                  </>
                )}
              </Card.Body>
            </Card>
          </Col>
        </Row>

        <Modal size="lg" aria-labelledby="contained-modal-title-vcenter" centered show={video !== ""} onHide={() => setVideo("")}>
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-vcenter">Video Resource</Modal.Title>
          </Modal.Header>
          <Modal.Body className="p-3" style={{ background: "#F8FAFC" }}>
            <VideoPlayer src={video} title="Video Resource" />
          </Modal.Body>
        </Modal>
      </div>
    </React.Fragment>
  );
};

export default Resources;
